export default "__VITE_ASSET__Cpg53on5__"